<template>
  <div class="inside">
    <el-dropdown @command="handleCommand" class="dropdown" trigger="hover">
      <el-button class="dropdown">
        {{ dropdown }}
        <img src="@/assets/images/bookIcons/downarrow.png" class="img" />
      </el-button>
      <el-dropdown-menu slot="dropdown" class="dropdown-detail">
        <el-dropdown-item command="全部">全部</el-dropdown-item>
        <el-dropdown-item command="书名">书名</el-dropdown-item>
        <el-dropdown-item command="目录标引">目录标引</el-dropdown-item>
        <el-dropdown-item command="全文">全文</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <div class="input-wrapper">
      <el-input  placeholder="请输入检索词" v-model="input" class="input" @keyup.enter.native="handleSearch">
        <img
          slot="prefix"
          src="@/assets/images/bookIcons/search.png"
          class="search-img"
          @click="handleSearch"
        />
      </el-input>
      <div class="tips">
        可用“+”表示“与”，“空格”表示“或”，"-"表示非 进行组合检索

      </div>
    </div>
    <div>
        <div class="inline_button">
            <button class="confirm" data-warden-title="检索结果" :data-warden-info="`${dropdown}检索--${input}`" @click="handleSearch">检索</button>
            <div v-if="doubleSearch">
                <button class="confirm" data-warden-title="检索结果" :data-warden-info="`${dropdown}检索--${input}`" @click="handleDoubleSearch">二次检索</button>
            </div>
            <button class="confirm" @click="handleAdvancedSearch">高级检索</button>
        </div>
        <div class="fuzzy">
        <el-checkbox v-model="fuzzySearch">模糊检索</el-checkbox>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RetrieveSearchBar',
  props: {
    initText: {
      type: String,
      default: ''
    },
    doubleSearch: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dropdown: '全部',
      input: '',
      commandMap: {
        全部: 'all',
        书名: 'bookName',
        目录标引: 'directory',
        全文: 'text'
      },
      fuzzySearch: false
    }
  },
  mounted () {
    this.input = this.$route.query.searchText
  },
  methods: {
    handleCommand (command) {
      this.dropdown = command
    },
    handleAdvancedSearch () {
      this.$router.push('/retrieve/advancedSearch')
    },
    handleSearch () {
      this.$global.searchDTO.sideBarInfo = {
        sideBarClassify: [],
        sideBarLibrarySite: [],
        sideBarDynasty: [],
        sideBarEdition: [],
        sideBarYear: [],
        sideBarAuthor: []
      }
      this.$global.advancedSearchDTO.sideBarInfo = {
        sideBarClassify: [],
        sideBarLibrarySite: [],
        sideBarDynasty: [],
        sideBarEdition: [],
        sideBarYear: [],
        sideBarAuthor: []
      }
      this.$global.searchDTO.returnType = 'all'
      this.$global.advancedSearchDTO.returnType = 'all'
      //   console.log('点击搜索按钮，当前的SearchDTO', this.$global.searchDTO)
      this.$emit('search', this.input, this.commandMap[this.dropdown], !this.fuzzySearch)
    //   this.input = ''
    },
    handleDoubleSearch () {
      if (this.input) {
        this.$global.searchDTO.returnType = 'all'
        this.$global.advancedSearchDTO.returnType = 'all'
        this.$emit('myDoubleSearch', this.input, this.commandMap[this.dropdown], !this.fuzzySearch)
      } else {
        this.$message({
          message: '请输入检索词',
          type: 'warning'
        })
      }

    //   this.input = ''
    }
  },
  watch: {
    $route: {
      handler (val) {
        if (val.path === '/retrieve/retrieveHome/introduction') {
          this.input = ''
          this.doubleSearch = false
        } else {
          this.doubleSearch = true
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
.fuzzy{
    margin: 10px 0 0 10px;
    text-align: left;
    font-size: 16px;
}
.inline_button{
    display: flex;
}
.inside >>> .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  border-color: #9e5c1d;
  background-color: #9e5c1d;
}

/* .inside .fuzzy>>>.el-checkbox:last-of-type {
    margin-top: 30px;
  display: flex;
    align-items: center;
  margin-right: 0;
} */

.inside .fuzzy >>> .el-checkbox__input+.el-checkbox__label {
    color: #634c37;
    font-size: 16px;
    font-weight: bold;
}

.inside >>> .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #9e5c1d;
  /* font-size: 16px; */
}

.inside >>> .el-checkbox__input.is-checked+.el-checkbox__label::before {
  border-color: #9e5c1d;
  background-color: #9e5c1d;
}
.inside {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 35px 0px 10px 0px;
  height: #9e5c1d;
}

.dropdown {
  width: 165px;
  height: 40px;
  text-align: left;
  border-radius: 0;
}

.img {
  width: 15px;
  float: right;
  transition: all 0.3s;
}

.dropdown-detail {
  width: 165px;
}

.input {
  width: 658px;
  height: 40px;
  background: #ffffff;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  margin-left: 13px;
  font-size: 16px;
}

.search-img {
  width: 23px;
  height: 23px;
}

.inside >>> .el-button {
  color: #634c37;
  font-size: 16px;
}

.input >>> .el-input__suffix {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  cursor: pointer;
  /* border: solid #634c37; */
}

.input >>> .el-input__prefix {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  cursor: pointer;
  /* border: solid #634c37; */
}

.input >>> .el-input__suffix:hover {
  background-color: #00000011;
}

.input >>> .el-input__inner {
  padding-left: 60px;
  border-radius: 0;
}

.confirm {
  width: 93px;
  height: 40px;
  background: #9e5c1d;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  border: 0;
  padding: 0;
  font-size: 16px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
  margin-left: 10px;
}

.el-button:focus,
.el-button:hover {
  color: #9e5c1d;
  background-color: #ffffff;
  border-color: #9e5c1d;
}

/* .el-button:focus .img, */
.el-button:hover .img {
  transform: rotate(180deg);
}

.el-dropdown:hover,
.el-dropdown:focus {
  color: #9e5c1d;
  background-color: #ffffff;
  border-color: #ecded1;
}

.dropdown-detail >>> .el-dropdown-menu__item:hover {
  color: #9e5c1d;
  background-color: #ecded1;
  border-color: #9e5c1d;
}

.input >>> .el-input__inner:focus {
  border-color: #9e5c1d;
}

.input-wrapper {
  display: flex;
  flex-direction: column;
}

.input-wrapper .tips {
  font-size: 14px;
  color: #634c37;
  margin-top: 10px;
  text-align: left;
  padding-left: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/RetrieveSearchBar.vue